<template>
  <div id="app" v-scroll="handleScroll">
    <Navbar />

    <div class="background-gradient">
    <Hero />

    <b-container>
      <About />
    </b-container>
    </div>

    <ProductDetails />
    <ProductGallery />

    <b-container>
      <ProductColors />
      <ContactForm />
      <Partners />
    </b-container>

    <Footer />
  </div>
</template>

<script>
import Navbar from "./components/Navbar.vue";
import Hero from "./components/Hero.vue";


import About from "./components/About.vue";
import ProductDetails from "./components/ProductDetails.vue";
import ProductGallery from "./components/ProductGallery.vue";
import ProductColors from "./components/ProductColors.vue";
import ContactForm from "./components/ContactForm.vue";
import Partners from "./components/Partners.vue"
import Footer from "./components/Footer.vue"

export default {
  name: "App",
  components: {
    Navbar,
    Hero,
    // Hero1,
    // Hero2,
    About,
    ProductDetails,
    ProductGallery,
    ProductColors,
    ContactForm,
    Partners,
    Footer
  },

  methods: {
    handleScroll: function() {
      if (window.scrollY > 0) {
        document.querySelector("body").classList.add("scrolled");
      } else if (window.scrollY === 0) {
        document.querySelector("body").classList.remove("scrolled");
      }
    },
  },
};
</script>

<style>
#app {
  font-family: "Montserrat", sans-serif;
}

.background-gradient {
  padding-top: 93px;
  /* background-image: linear-gradient(179.5deg,#78b135 27.7%,#f6f6f6 96.3%) */
}

.container {
  padding-right: 15px;
  padding-left: 15px;
}

.scrolled #home {
  background-color: white;
  transition-duration: 0.5s;
}

.scrolled .navbar-light .navbar-nav a.nav-link {
  color: #2f2911;
}

p {
  font-size: 16px;
}

@media (max-width: 767.98px) {
  .text-center {
    padding: 20px;
  }

  .text {
    padding: 20px;
  }

  .text-form {
    padding: 20px;
    text-align: center;
  }

  .hero {
    /* height: 300px; */
  }

  .first {
    /* margin-top: 175px; */
  }

  .first h1 {
    font-size: 35px;
  }

}
</style>
